import React, { useEffect, useState } from 'react';
import Menu from '../../../components/sturtural/Menu';
import { BASE_API } from '../../../api/Globals';
import { helpHttp } from '../../../helpers/helpHttp';
import TableData from '../../../components/sturtural/TableData';
import Loader from '../../../components/sturtural/Loader';
import MessageDetail from '../../../components/sturtural/MessageDetail';
import UserFormReAssignment from '../../../components/users/UserFormReAssignment';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DemandListReassignment = () => {

    const [db, setDb] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [solicitudid, setSolicitudId] = useState(null);
    const [displayWarning, setDisplayWarning] = useState(false);
    
    let url = `${BASE_API}demand/inreview`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setDb(res.demand);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false);
        });
    },[url]);


    const handleAssignment = (solicitudid) => {
        setSolicitudId(solicitudid);
        setDisplayBasic(true);
    }

    const handleHidden = () => {
        setDisplayBasic(false);

        let newDb = db.filter((el) => el.solicitudid !== solicitudid);
        setDb(newDb);

        setDisplayWarning(true);
    }

    const thead = [
        '#',
        'NOMBRE (Solicitante)',
        'VALIDADOR',
        'FECHA ASIGNACIÓN',
        'INSTITUCIÓN EDUCATIVA',
        'TÍTULO',
        'CORREO ELECTRÓNICO',
        'TELÉFONO',
        '...'
    ]

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => setDisplayWarning(false)} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <Menu link='reasignar' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Reasignación de solicitudes</h5>
                        <p>De la siguiente lista de solicitudes en espera, seleccione una para darle seguimiento.</p>
                        {loading && <Loader />}
                        {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                        {db && <TableData  thead={thead} data={db} handleAssignment={handleAssignment} />}
                        {db && <Dialog header="Asignar validador" visible={displayBasic} style={{ width: '35vw' }} modal onHide={() => setDisplayBasic(false)}>
                            <UserFormReAssignment solicitudid={solicitudid} handleHidden={handleHidden}/>
                        </Dialog>}
                    </div>
                </div>
            </div>

            <Dialog header="Aviso" visible={displayWarning} style={{ width: '30vw' }} modal footer={basicDialogFooter} onHide={() => setDisplayWarning(false)}>
                <p>El proceso de reasignación se ha realizado correctamente</p>
            </Dialog>
        </>
    );
}

export default DemandListReassignment;